exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-spinner{height:100px;width:100px;margin:0 auto}.loading-spinner--wrapper{width:100%}.loading-spinner svg{width:100%;height:100%}.loading-spinner__animate{transform-origin:50% 100%;transform-box:fill-box;animation:spinner 1s linear infinite}@keyframes spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/LoadingSpinner/LoadingSpinner.scss
// module id = 682
// module chunks = 0